import { IS_LOADABLE } from './../../action-types/bookproperties/';

export const STATE_KEY = 'isLoadable';

export const isLoadable = (state = true, action) => {
  switch (action.type) {
    case IS_LOADABLE: {
      return action.flag;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/bookproperties/isLoadable.js